import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import type { TradeAllocationPersistedTabContent } from 'apiConnector/tabs/tabs.model';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { EMPTY, of } from 'rxjs';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabCreated } from 'state/workspaces/workspace.actions';
import { throwOnTimeout } from 'utils/rxjs';

export function createTradeAllocationTabEpic(
  timeoutInMillis: number = 60000,
  appScheduler?: SchedulerLike,
): EpicWithThunk {
  return (action$, _state$, { navigateTo, httpClient }) => {
    return action$.pipe(
      ofType('TRADE_ALLOCATION_TAB_CREATED'),
      mergeMap(({ tabId, tradeId, tabName, product, isin, fileCode, wrapper, productId, rfqId }) => {
        const content: TradeAllocationPersistedTabContent = {
          workspace: 'postTrade',
          tabType: 'tradeAllocation',
          tradeId,
          product,
          wrapper,
          fileCode,
          isin,
          productId,
          rfqId,
        };

        return tabsApiConnector(httpClient, 'postTrade')
          .updateTabContent(tabId, content)
          .pipe(
            throwOnTimeout(timeoutInMillis, `Timeout after ${timeoutInMillis}ms.`, appScheduler),
            mergeMap(() => of(workspaceTabCreated(tabId, content.workspace, content.tabType, tabName))),
            tap(() => {
              navigateTo('/post-trade');
            }),
            catchError(() => EMPTY),
          );
      }),
    );
  };
}
